'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SpicySvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SpicySvg(props) {
    var width = props.width,
        height = props.height,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'fullimgSpicy', width: width, height: height, viewBox: '0 0 13 27', xmlns: 'http://www.w3.org/2000/svg',
            'data-hook': 'wixrest-menus-icon-full-spicy' },
        _react2.default.createElement(
            'title',
            { id: 'fullimgSpicy' },
            ' ',
            i18n.get('openrest_menubuilderv3_dishlabels_spicy') || 'spicy'
        ),
        _react2.default.createElement('path', {
            d: 'M9.037 4.48c-.668.642-.855 1.81-.907 2.575-1.286.023-2.04.505-2.453.946-.77.823-1.016 2.092-.732 3.776.034.205.076.42.12.643.175.87.372 1.858.18 2.917-.468 2.568-2.168 3.402-3.532 4.072-.932.456-1.985.972-1.65 2.097.078.263.33.723 1.122.835.49.072 1.143-.003 1.877-.2 2.207-.592 5.153-2.294 6.615-4.558 2.175-3.364 2.938-6.68 1.995-8.653-.312-.647-.946-1.433-2.213-1.742.04-.67.195-1.45.505-1.75.086-.083.168-.11.295-.103.363.03.687-.25.714-.615.028-.368-.25-.688-.618-.715-.505-.038-.96.127-1.32.474m1.217 4.85c.247-.083.578.07.666.348.032.106.785 2.6-1.123 5.486-.075.113-.187.188-.31.22-.14.038-.3.02-.43-.07-.248-.162-.315-.494-.153-.74 1.614-2.442 1.02-4.492.995-4.578-.088-.282.07-.58.353-.666',
            fill: primaryColor })
    );
}

SpicySvg.displayName = 'SpicySvg';
SpicySvg.propTypes = {
    width: _propTypes2.default.number,
    height: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
SpicySvg.defaultProps = {
    width: 13,
    height: 27,
    primaryColor: '#c4270e'
};